export const PromocodeErrors = {
  notFound: "promotional_code_not_found",
  expired: "promotional_code_expired",
  inactive: "promotional_code_inactive",
  conflict: "promotional_code_conflict",
  limit: "promotional_code_limit_exceeded",
  restricted: "promotional_code_restricted",
}